module.exports = __webpack_public_path__ + "static/media/Nl-raja.d13b31a2.png";